<app-my-json-ld [itemLD]="json1"></app-my-json-ld>
<app-my-json-ld [itemLD]="json2"></app-my-json-ld>
<app-my-json-ld [itemLD]="json3"></app-my-json-ld>
<app-my-json-ld [itemLD]="json4"></app-my-json-ld>

<app-header [pageType]="'home'" (change)="changeQuiz($event)"></app-header>

<div class="bannersmall2">
    <img alt="" class="img-fluid" src="https://media.iquanta.in/ui_images/public_portal_img/inner2.png">
    <div class="container">
        <div class="row">
            <div class="col-md-8">
                <div class="innerhero">
                    <div class="page-header">
                        <div class="page-block">
                            <div class="row align-item-center">
                                <div class="col-md-12">
                                    <div class="flex align-item-center">
                                        <ul class="breadcrumb align-item-center">
                                            <li class="breadcrumb-item">
                                                <a href="/">Home</a>
                                            </li>
                                            <li class="breadcrumb-item">
                                                <a href="/test">Test</a>
                                            </li>
                                            <li class="breadcrumb-item">
                                                <a>{{mockName}}</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item" [routerLink]="'/'"><a>Home</a></li>
                            <li class="breadcrumb-item"><a>Test</a></li>
                            <li class="breadcrumb-item"><a>{{mockName}}</a></li>
                        </ol>
                    </nav> -->

                    <h1 *ngIf="mockName == 'CMAT'">CMAT Previous Years Papers</h1>
                    <h1 *ngIf="mockName != 'CMAT' && mockName != 'Free CAT Study Material' && mockName != 'iConcept'">
                        {{mockName}} Previous Year Papers</h1>
                    <p *ngIf="mockName == 'IPMAT'">Explore our comprehensive collection of IPMAT Previous Year Papers to
                        enhance your preparation. Dive into detailed solutions and expert analysis, tailored to boost
                        your understanding and exam readiness.</p>
                    <h1 *ngIf="mockName == 'Free CAT Study Material' || mockName == 'iConcept'">Best CAT Study Material
                        For CAT Exam</h1>
                </div>

            </div>

            <div class="col-md-4">
                <div class="search_img pl-4">
                    <!-- <img alt="" class="img-fluid" src="https://media.iquanta.in/ui_images/cat-2025.jpg"
                        [routerLink]="'/cat-2025'" alt=""> -->

                </div>
            </div>
        </div>
    </div>
</div>


<div class="xat-bottom-content clat-content" *ngIf="mockName == 'CLAT'">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-10 full_width_tab">
                <h2 class="mt-md-4 text-center">CLAT Previous Year Question Papers </h2>
                <p>Explore our comprehensive collection of CLAT Previous Year Question Papers. This resource offers
                    detailed insights into the exam pattern and types of questions. </p>
                <h2 class="mt-md-4 text-center">CLAT Question Paper with Detailed Solution</h2>
                <p>The CLAT previous year papers are an essential tool for the aspirants taking the CLAT exam. CLAT is a
                    national level exam conducted by the NTA to get admission into the top law universities. After the
                    exam, the Consortium will release the CLAT question paper and answer key. It is suggested that the
                    candidates must go through the CLAT previous year papers to prepare for the upcoming exam. </p>
                <p>CLAT exam papers will help to improve the problem solving Techniques and give an insight about the
                    types of questions asked, exam pattern, etc. To ace the CLAT exam CLAT question paper is the key
                    step. </p>
                <h3 class="mt-md-4 text-center">CLAT Previous Year Paper Pattern</h3>
                <p>Check below the paper pattern of the CLAT exam:</p>
                <table class="table table-bordered">
                    <thead>
                        <tr>

                            <th scope="col">Particulars</th>
                            <th scope="col">Details</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>

                            <td>Exam</td>
                            <td>CLAT</td>
                        </tr>
                        <tr>

                            <td>Language of Question Paper </td>
                            <td>English</td>
                        </tr>
                        <tr>

                            <td>Duration</td>
                            <td>2 hours</td>
                        </tr>
                        <tr>
                            <td>Mode</td>
                            <td>Offline</td>
                        </tr>
                        <tr>
                            <td>Sections</td>
                            <td>English Language<br>
                                General Knowledge<br>
                                Quantitative Techniques<br>
                                Logical Reasoning<br>
                                Legal Reasoning
                            </td>
                        </tr>
                        <tr>
                            <td>Types of Questions</td>
                            <td>MCQs</td>
                        </tr>
                        <tr>
                            <td>Number of Questions</td>
                            <td>120</td>
                        </tr>
                        <tr>
                            <td>Total Marks</td>
                            <td>120</td>
                        </tr>

                        <tr>
                            <td>Marking Scheme</td>
                            <td>Correct Answer = +1 mark</td>
                        </tr>
                        <tr>
                            <td></td>
                            <td>Incorrect Answer = 0.25 mark</td>
                        </tr>
                    </tbody>
                </table>
                <h3 class="mt-md-4 text-center">Benefits of CLAT Past Year Papers</h3>
                <p>Check below the advantages of CLAT past year papers:</p>
                <ul>
                    <li>By Solving previous year papers of CLAT candidates will get an idea about the CLAT exam pattern.
                        This will help to understand the structure of the CLAT exam such as the section-wise
                        distribution of the paper.</li>
                    <li>Candidates will get familiarised with the types of questions such as logical reasoning, legal
                        reasoning, english, etc. This will help to tackle each question easily and confidently. </li>
                    <li>They will learn to identify the important CLAT topics by practicing CLAT question papers. The
                        high priority topics can be easily identified. </li>
                    <li>With more and more practice the time management skills will enhance. This in order will improve
                        the speed and accuracy. Time management and speed and accuracy is an important factor as the
                        candidates are required to complete the paper within the given time limits. </li>
                    <li>By practicing CLAT question paper, the aspirants will be able to assess their level of
                        preparation. This will help them to develop problem solving techniques. They will learn many
                        shortcuts, critical thinking techniques and elimination methods, etc.</li>
                </ul>
                <h3 class="mt-md-4 text-center">CLAT Exam Paper Analysis </h3>
                <p>Check below the difficulty level of the CLAT exam based on previous year analysis:</p>
                <table class="table table-bordered">
                    <thead>
                        <tr>

                            <th scope="col">Sections</th>
                            <th scope="col">Difficulty Level</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>

                            <td>English Language</td>
                            <td>Easy to Moderate</td>
                        </tr>
                        <tr>

                            <td>General Knowledge </td>
                            <td>Moderate</td>
                        </tr>
                        <tr>

                            <td>Legal Reasoning</td>
                            <td>Easy</td>
                        </tr>
                        <tr>
                            <td>Quantitative Techniques</td>
                            <td>Difficult</td>
                        </tr>
                        <tr>
                            <td>Logical Reasoning</td>
                            <td>Moderate</td>
                        </tr>

                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>

<div class="clearfix"></div>
<div class="corse_full_details pb-md-5 pt-md-5 bg-white">
    <div class="container">
        <div class="row d-flex justify-content-center">
            <div class="col-md-11">
                <div class="result_card position-static">
                    <div class="result_free_det pt-md-2">
                        <div class="container">
                            <div class="row d-md-flex justify-content-center">
                                <div class="col-md-6">
                                    <div class="course_image mobile_none">
                                        <div class="img" [routerLink]="'/cat-2025'">
                                            <img src="https://media.iquanta.in/ui_images/BANNER-mob.webp">
                                        </div>
                                    </div>
                                    <div class="course_image desk_none">
                                        <div class="img" [routerLink]="'/cat-2025'">
                                            <img src="https://media.iquanta.in/ui_images/BANNER-mob.webp">
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="neet-counselling-form p-4">
                                        <h5 class="f-bold mb-sm-3 pl-sm-2 text-center">Start your Journey Today !</h5>
                                        <form class="pl-sm-2">
                                            <div class="row">
                                                <div class="col-md-12 col-12 ">
                                                    <div class="form-group">
                                                        <input placeholder="Enter your name" formControlName="name"
                                                            type="text" class="form-control f-light">
                                                    </div>
                                                </div>
                                                <div class="col-md-12 col-12">
                                                    <div class="form-group">
                                                        <input placeholder="Enter your number" type="text"
                                                            formControlName="mobile" class="form-control f-light">
                                                    </div>
                                                </div>
                                                <div class="col-md-12">
                                                    <div class="form-group">
                                                        <input placeholder="Enter your email" type="text"
                                                            formControlName="email" class="form-control f-light">
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <select formControlName="course" class="form-select"
                                                        aria-label="Default select example">
                                                        <option selected>Select Course</option>
                                                        <option value="CAT">CAT</option>
                                                        <option value="GDPI">GDPI</option>
                                                        <option value="GMAT">GMAT</option>
                                                        <option value="XAT">XAT</option>
                                                        <option value="CMAT">CMAT</option>
                                                        <option value="MICAT">MICAT</option>
                                                        <option value="CUET PG">CUET PG</option>
                                                        <option value="CUET UG">CUET UG</option>
                                                        <option value="IPMAT">IPMAT</option>
                                                        <option value="CLAT">CLAT</option>
                                                    </select>
                                                </div>

                                                <div class="col-md-6 pr-1">
                                                    <div class="form-group mb-0">

                                                        <select formControlName="time" class="form-control"
                                                            id="exampleFormControlSelect1">
                                                            <option value="" [hidden]="">Select Time slot</option>
                                                            <option value="1 PM">1 PM</option>
                                                            <option value="3 PM">3 PM</option>
                                                            <option value="5 PM">5 PM</option>
                                                            <option value="10 PM">10 PM</option>
                                                        </select>
                                                    </div>
                                                </div>

                                                <div class="col-md-12 col-12 pt-2">
                                                    <div class="header-actions h-100">
                                                        <button class="btn f-bold">
                                                            Book Free Counselling Session
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="clearfix"></div>
<div class="pb-md-5 pt-md-2">
    <div class="container">
        <div class="row d-flex justify-content-center">
            <div class="col-md-11">
                <div class="row justify-content-center">
                    <div class="col-md-3 p-0" *ngFor="let mockmain of mockDataList;let i = index">
                        <div class="quiz_sub_cat">
                            <h4 (click)="scrollto(i)"> {{mockmain.sub_category}}
                            </h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="clearfix"></div>

<div class="appear-mocks" id="mocks" *ngIf="mockName == 'CAT'">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-10">
                <div class="cheat-text middle">
                    <div class="d-md-flex justify-content-between">
                        <h2>To appear for CAT previous year papers in Full Mock format</h2>
                        <button mat-raised-button routerLink="/cat-mock-test"> Click Here</button>
                    </div>
                </div>
            </div>
            <div class="col-md-10">
                <div class="d-md-flex justify-content-between">
                    <h2>To appear for CAT previous year papers in Sectional Mock format</h2>
                    <button mat-raised-button (click)="scrollto(0)"> Click Here</button>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="career_opens_main py-md-5" id="mocks" *ngIf="mockName == 'CUET'">
    <div class="container">
        <div class="row d-flex justify-content-center">
            <div class="col-md-9 full_width_tab">

                <h2>CUET UG Mocks 2025</h2>

                <div class="mock-tab">
                    <div class="d-flex justify-content-center">
                        <div class="headder-courses headder-courses1 ">
                            <h3 class="cat-box " [ngClass]="{'active': tabVal == 'past'}" (click)="changeTab('past')">
                                <i class="bi bi-check-circle-fill"></i>
                                <p>CUET Past Papers</p>
                                <div class="count">
                                    {{pastList.length}}
                                </div>
                            </h3>
                        </div>
                        <div class="headder-courses headder-courses1 ">
                            <h3 class="cat-box " [ngClass]="{'active': tabVal == 'full'}" (click)="changeTab('full')">
                                <i class="bi bi-check-circle-fill"></i>
                                <p>English Language</p>
                                <div class="count">
                                    {{fullmockDetailList.length}}
                                </div>
                            </h3>
                        </div>
                        <div class="headder-courses headder-courses1 ">
                            <h3 class="cat-box" [ngClass]="{'active': tabVal == 'sectional'}"
                                (click)="changeTab('sectional')">
                                <i class="bi bi-list-check"></i>
                                <p>Domains</p>
                                <div class="count">
                                    {{quantMockList.length + varcMockList.length + lrdiMockList.length}}
                                </div>
                            </h3>
                        </div>


                        <div class="headder-courses headder-courses1 mobile-none">
                            <h3 class="cat-box" [ngClass]="{'active': tabVal == 'pastpapers'}"
                                (click)="changeTab('pastpapers')">
                                <i class="bi bi-check-circle-fill"></i>
                                <p>General Test</p>
                                <div class="count">
                                    {{pastPapers.length}}
                                </div>
                            </h3>
                        </div>

                    </div>

                    <ng-container *ngIf="tabVal == 'sectional'">
                        <div class="d-flex justify-content-center">
                            <div class="headder-courses headder-courses1 ">
                                <h3 class="cat-box " [ngClass]="{'active': tabVal1 == 'quant'}"
                                    (click)="changeTab1('quant')">

                                    <p>Commerce</p>
                                    <div class="count">
                                        {{quantMockList.length}}
                                    </div>
                                </h3>
                            </div>
                            <div class="headder-courses headder-courses1 ">
                                <h3 class="cat-box" [ngClass]="{'active': tabVal1 == 'varc'}"
                                    (click)="changeTab1('varc')">

                                    <p>Science</p>
                                    <div class="count">
                                        {{varcMockList.length}}
                                    </div>
                                </h3>
                            </div>
                            <div class="headder-courses headder-courses1 ">
                                <h3 class="cat-box" [ngClass]="{'active': tabVal1 == 'lrdi'}"
                                    (click)="changeTab1('lrdi')">

                                    <p>Humanities</p>
                                    <div class="count">
                                        {{lrdiMockList.length}}
                                    </div>
                                </h3>
                            </div>
                        </div>
                    </ng-container>

                </div>
                <p class="desk-none tab-text"><span>This mock platform is made for desktops/laptop only.</span>
                    Kindly visit this page from your desktop/laptop to
                    attempt free or purchased mocks.</p>

                <div class="career_opens mt-4">

                    <ul *ngIf="tabVal == 'pastpapers'">
                        <li class="d-flex justify-content-between" *ngFor="let mock of pastPapers">
                            <div class="caree_title d-flex">
                                <h3>{{mock.name}}</h3>
                                <p *ngIf="!mock.launch" style="color: #f44336">Live Now</p>
                                <p *ngIf="mock.launch">Start Date {{mock.launch}}</p>
                            </div>

                            <ng-container *ngIf="!mock.launch && !mock.paid; else paidBtn">
                                <div class="mobile-none">
                                    <div class="career_btn d-flex align-items-end">
                                        <button *ngIf="mock.status == '' || !mock.status" (click)="startMock(mock)"
                                            style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                            mat-flat-button color="primary">
                                            <span><img src="https://media.iquanta.in/ui_images/rocket.png"></span>Start
                                            Mock</button>

                                        <button *ngIf="mock.status == 1" (click)="resume(mock)"
                                            style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                            mat-flat-button color="primary">
                                            <span><img
                                                    src="https://media.iquanta.in/ui_images/rocket.png"></span>Resume</button>

                                        <button *ngIf="mock.status == 2" (click)="viewanalysis(mock)"
                                            style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                            mat-flat-button color="primary">
                                            <span><img src="https://media.iquanta.in/ui_images/rocket.png"></span>View
                                            Analysis</button>
                                    </div>
                                </div>

                                <div class="desk-none">
                                    <div class="career_btn d-flex align-items-end">
                                        <button style="background-color: #fff;border:1px solid #fff;
                                                color:#000;margin-right:0;    line-height: initial;
    padding: 0;height:auto;
    " mat-flat-button color="primary">
                                            Attempt From Desktop</button>
                                    </div>
                                </div>

                            </ng-container>

                            <ng-template #paidBtn>
                                <div class="career_btn d-flex align-items-start">
                                    <button *ngIf="mock.paid" style="background-color: #f44336;border:1px solid #f44336"
                                        (click)="goto('packages')" mat-flat-button color="primary">Paid</button>

                                    <button [matTooltip]="'This free mock will be available from '+mock.launch"
                                        *ngIf="!mock.paid" #myTooltip="matTooltip" (click)="displayTooltip()"
                                        style="background-color: #11830d;border:1px solid #11830d" mat-flat-button
                                        color="primary">Purchased</button>

                                    <button *ngIf="mock.lock" class="mobile-none"
                                        style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                        mat-flat-button color="primary">
                                        <i class="bi bi-lock-fill"></i> Locked</button>


                                    <ng-container *ngIf="mock.lock">
                                        <button class="desk-none"
                                            style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                            mat-flat-button color="primary">
                                            <i class="bi bi-lock-fill"></i> </button>
                                    </ng-container>


                                </div>
                            </ng-template>

                        </li>



                    </ul>



                    <ul *ngIf="tabVal == 'past'">
                        <li class="d-flex justify-content-between" *ngFor="let mock of pastList.slice(0, loadmore2)">
                            <div class="caree_title d-flex">
                                <h3>{{mock.name}}</h3>
                                <p *ngIf="!mock.launch" style="color: #f44336">Live Now</p>
                                <p *ngIf="mock.launch">Start Date {{mock.launch}}</p>
                            </div>

                            <ng-container *ngIf="!mock.launch && !mock.paid; else paidBtn">
                                <div class="mobile-none">
                                    <div class="career_btn d-flex align-items-end">
                                        <button *ngIf="mock.status == '' || !mock.status" (click)="startMock(mock)"
                                            style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                            mat-flat-button color="primary">
                                            <span><img src="https://media.iquanta.in/ui_images/rocket.png"></span>Start
                                            Mock</button>

                                        <button *ngIf="mock.status == 1" (click)="resume(mock)"
                                            style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                            mat-flat-button color="primary">
                                            <span><img
                                                    src="https://media.iquanta.in/ui_images/rocket.png"></span>Resume</button>

                                        <button *ngIf="mock.status == 2" (click)="viewanalysis(mock)"
                                            style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                            mat-flat-button color="primary">
                                            <span><img src="https://media.iquanta.in/ui_images/rocket.png"></span>View
                                            Analysis</button>
                                    </div>
                                </div>

                                <div class="desk-none">
                                    <div class="career_btn d-flex align-items-end">
                                        <button style="background-color: #fff;border:1px solid #fff;
                                                color:#000;margin-right:0;    line-height: initial;
    padding: 0;height:auto;
    " mat-flat-button color="primary">
                                            Attempt From Desktop</button>
                                    </div>
                                </div>

                            </ng-container>

                            <ng-template #paidBtn>
                                <div class="career_btn d-flex align-items-start">
                                    <button *ngIf="mock.paid" style="background-color: #f44336;border:1px solid #f44336"
                                        (click)="goto('packages')" mat-flat-button color="primary">Paid</button>

                                    <button [matTooltip]="'This free mock will be available from '+mock.launch"
                                        *ngIf="!mock.paid" #myTooltip="matTooltip" (click)="displayTooltip()"
                                        style="background-color: #11830d;border:1px solid #11830d" mat-flat-button
                                        color="primary">Purchased</button>

                                    <button *ngIf="mock.lock" class="mobile-none"
                                        style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                        mat-flat-button color="primary">
                                        <i class="bi bi-lock-fill"></i> Locked</button>


                                    <ng-container *ngIf="mock.lock">
                                        <button class="desk-none"
                                            style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                            mat-flat-button color="primary">
                                            <i class="bi bi-lock-fill"></i> </button>
                                    </ng-container>


                                </div>
                            </ng-template>

                        </li>



                    </ul>

                    <ul *ngIf="tabVal == 'full'">
                        <li class="d-flex justify-content-between"
                            *ngFor="let mock of fullmockDetailList.slice(0, loadmore1)">
                            <div class="caree_title d-flex">
                                <h3>{{mock.name}}</h3>
                                <p *ngIf="!mock.launch" style="color: #f44336">Live Now</p>
                                <p *ngIf="mock.launch">Start Date {{mock.launch}}</p>
                            </div>

                            <ng-container *ngIf="!mock.launch && !mock.paid; else paidBtn">
                                <div class="mobile-none">
                                    <div class="career_btn d-flex align-items-end">
                                        <button *ngIf="mock.status == '' || !mock.status" (click)="startMock(mock)"
                                            style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                            mat-flat-button color="primary">
                                            <span><img src="https://media.iquanta.in/ui_images/rocket.png"></span>Start
                                            Mock</button>

                                        <button *ngIf="mock.status == 1" (click)="resume(mock)"
                                            style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                            mat-flat-button color="primary">
                                            <span><img
                                                    src="https://media.iquanta.in/ui_images/rocket.png"></span>Resume</button>

                                        <button *ngIf="mock.status == 2" (click)="viewanalysis(mock)"
                                            style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                            mat-flat-button color="primary">
                                            <span><img src="https://media.iquanta.in/ui_images/rocket.png"></span>View
                                            Analysis</button>
                                    </div>
                                </div>

                                <div class="desk-none">
                                    <div class="career_btn d-flex align-items-end">
                                        <button style="background-color: #fff;border:1px solid #fff;
                                                color:#000;margin-right:0;    line-height: initial;
    padding: 0;height:auto;
    " mat-flat-button color="primary">
                                            Attempt From Desktop</button>
                                    </div>
                                </div>

                            </ng-container>

                            <ng-template #paidBtn>
                                <div class="career_btn d-flex align-items-start">
                                    <button *ngIf="mock.paid" style="background-color: #f44336;border:1px solid #f44336"
                                        (click)="goto('packages')" mat-flat-button color="primary">Paid</button>

                                    <button [matTooltip]="'This free mock will be available from '+mock.launch"
                                        *ngIf="!mock.paid" #myTooltip="matTooltip" (click)="displayTooltip()"
                                        style="background-color: #11830d;border:1px solid #11830d" mat-flat-button
                                        color="primary">Purchased</button>

                                    <button *ngIf="mock.lock" class="mobile-none"
                                        style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                        mat-flat-button color="primary">
                                        <i class="bi bi-lock-fill"></i> Locked</button>


                                    <ng-container *ngIf="mock.lock">
                                        <button class="desk-none"
                                            style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                            mat-flat-button color="primary">
                                            <i class="bi bi-lock-fill"></i> </button>
                                    </ng-container>


                                </div>
                            </ng-template>

                        </li>



                    </ul>



                    <ul *ngIf="tabVal == 'sectional'">
                        <ng-container *ngIf="tabVal1 == 'quant'">
                            <li class="d-flex justify-content-between"
                                *ngFor="let mock of quantMockList.slice(0, loadmore2)">
                                <div class="caree_title d-flex">
                                    <h3>{{mock.name}}</h3>
                                    <p *ngIf="!mock.launch" style="color: #f44336">Live Now</p>
                                    <p *ngIf="mock.launch">Start Date {{mock.launch}}</p>
                                </div>

                                <ng-container *ngIf="!mock.launch && !mock.paid; else paidBtn1">
                                    <div class="mobile-none">
                                        <div class="career_btn d-flex align-items-end">
                                            <button *ngIf="mock.status == '' || !mock.status" (click)="startMock(mock)"
                                                style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                                mat-flat-button color="primary">
                                                <span><img
                                                        src="https://media.iquanta.in/ui_images/rocket.png"></span>Start
                                                Mock</button>

                                            <button *ngIf="mock.status == 1" (click)="resume(mock)"
                                                style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                                mat-flat-button color="primary">
                                                <span><img
                                                        src="https://media.iquanta.in/ui_images/rocket.png"></span>Resume</button>

                                            <button *ngIf="mock.status == 2" (click)="viewanalysis(mock)"
                                                style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                                mat-flat-button color="primary">
                                                <span><img
                                                        src="https://media.iquanta.in/ui_images/rocket.png"></span>View
                                                Analysis</button>
                                        </div>
                                    </div>

                                    <div class="desk-none">
                                        <div class="career_btn d-flex align-items-end">
                                            <button style="background-color: #fff;border:1px solid #fff;
                                                    color:#000;margin-right:0;    line-height: initial;
    padding: 0;height:auto;
    " mat-flat-button color="primary">
                                                Attempt From Desktop</button>
                                        </div>
                                    </div>
                                </ng-container>

                                <ng-template #paidBtn1>
                                    <div class="career_btn d-flex align-items-start">
                                        <button *ngIf="mock.paid"
                                            style="background-color: #f44336;border:1px solid #f44336"
                                            (click)="goto('packages')" mat-flat-button color="primary">Paid</button>

                                        <button [matTooltip]="'This free mock will be available from '+mock.launch"
                                            *ngIf="!mock.paid"
                                            style="background-color: #11830d;border:1px solid #11830d" mat-flat-button
                                            color="primary">Purchased</button>
                                        <button *ngIf="mock.lock" class="mobile-none"
                                            style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                            mat-flat-button color="primary">
                                            <i class="bi bi-lock-fill"></i> Locked</button>


                                        <ng-container *ngIf="mock.lock">
                                            <button class="desk-none"
                                                style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                                mat-flat-button color="primary">
                                                <i class="bi bi-lock-fill"></i> </button>
                                        </ng-container>


                                    </div>
                                </ng-template>

                            </li>
                        </ng-container>
                        <ng-container *ngIf="tabVal1 == 'varc'">
                            <li class="d-flex justify-content-between"
                                *ngFor="let mock of varcMockList.slice(0, loadmore2)">
                                <div class="caree_title d-flex">
                                    <h3>{{mock.name}}</h3>
                                    <p *ngIf="!mock.launch" style="color: #f44336">Live Now</p>
                                    <p *ngIf="mock.launch">Start Date {{mock.launch}}</p>
                                </div>

                                <ng-container *ngIf="!mock.launch && !mock.paid; else paidBtn2">
                                    <div class="mobile-none">
                                        <div class="career_btn d-flex align-items-end">
                                            <button *ngIf="mock.status == '' || !mock.status" (click)="startMock(mock)"
                                                style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                                mat-flat-button color="primary">
                                                <span><img
                                                        src="https://media.iquanta.in/ui_images/rocket.png"></span>Start
                                                Mock</button>

                                            <button *ngIf="mock.status == 1" (click)="resume(mock)"
                                                style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                                mat-flat-button color="primary">
                                                <span><img
                                                        src="https://media.iquanta.in/ui_images/rocket.png"></span>Resume</button>

                                            <button *ngIf="mock.status == 2" (click)="viewanalysis(mock)"
                                                style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                                mat-flat-button color="primary">
                                                <span><img
                                                        src="https://media.iquanta.in/ui_images/rocket.png"></span>View
                                                Analysis</button>
                                        </div>
                                    </div>

                                    <div class="desk-none">
                                        <div class="career_btn d-flex align-items-end">
                                            <button style="background-color: #fff;border:1px solid #fff;color:#000;
                                                    margin-right:0;    line-height: initial;
    padding: 0;height:auto;
    " mat-flat-button color="primary">
                                                Attempt From Desktop</button>
                                        </div>
                                    </div>
                                </ng-container>

                                <ng-template #paidBtn2>
                                    <div class="career_btn d-flex align-items-start">
                                        <button *ngIf="mock.paid"
                                            style="background-color: #f44336;border:1px solid #f44336"
                                            (click)="goto('packages')" mat-flat-button color="primary">Paid</button>

                                        <button [matTooltip]="'This free mock will be available from '+mock.launch"
                                            *ngIf="!mock.paid"
                                            style="background-color: #11830d;border:1px solid #11830d" mat-flat-button
                                            color="primary">Purchased</button>

                                        <button *ngIf="mock.lock" class="mobile-none"
                                            style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                            mat-flat-button color="primary">
                                            <i class="bi bi-lock-fill"></i> Locked</button>

                                        <ng-container *ngIf="mock.lock">
                                            <button class="desk-none"
                                                style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                                mat-flat-button color="primary">
                                                <i class="bi bi-lock-fill"></i> </button>
                                        </ng-container>


                                    </div>
                                </ng-template>

                            </li>
                        </ng-container>
                        <ng-container *ngIf="tabVal1 == 'lrdi'">
                            <li class="d-flex justify-content-between"
                                *ngFor="let mock of lrdiMockList.slice(0, loadmore2)">
                                <div class="caree_title d-flex">
                                    <h3>{{mock.name}}</h3>
                                    <p *ngIf="!mock.launch" style="color: #f44336">Live Now</p>
                                    <p *ngIf="mock.launch">Start Date {{mock.launch}}</p>
                                </div>

                                <ng-container *ngIf="!mock.launch && !mock.paid; else paidBtn3">
                                    <div class="mobile-none">
                                        <div class="career_btn d-flex align-items-end">
                                            <button *ngIf="mock.status == '' || !mock.status" (click)="startMock(mock)"
                                                style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                                mat-flat-button color="primary">
                                                <span><img
                                                        src="https://media.iquanta.in/ui_images/rocket.png"></span>Start
                                                Mock</button>

                                            <button *ngIf="mock.status == 1" (click)="resume(mock)"
                                                style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                                mat-flat-button color="primary">
                                                <span><img
                                                        src="https://media.iquanta.in/ui_images/rocket.png"></span>Resume</button>

                                            <button *ngIf="mock.status == 2" (click)="viewanalysis(mock)"
                                                style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                                mat-flat-button color="primary">
                                                <span><img
                                                        src="https://media.iquanta.in/ui_images/rocket.png"></span>View
                                                Analysis</button>
                                        </div>
                                    </div>

                                    <div class="desk-none">
                                        <div class="career_btn d-flex align-items-end">
                                            <button style="background-color: #fff;border:1px solid #fff;color:#000;
                                                    margin-right:0;    line-height: initial;
    padding: 0;height:auto;
    " mat-flat-button color="primary">
                                                Attempt From Desktop</button>
                                        </div>
                                    </div>
                                </ng-container>

                                <ng-template #paidBtn3>
                                    <div class="career_btn d-flex align-items-start">
                                        <button *ngIf="mock.paid"
                                            style="background-color: #f44336;border:1px solid #f44336"
                                            (click)="goto('packages')" mat-flat-button color="primary">Paid</button>

                                        <button [matTooltip]="'This free mock will be available from '+mock.launch"
                                            *ngIf="!mock.paid"
                                            style="background-color: #11830d;border:1px solid #11830d" mat-flat-button
                                            color="primary">Purchased</button>
                                        <button *ngIf="mock.lock" class="mobile-none"
                                            style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                            mat-flat-button color="primary">
                                            <i class="bi bi-lock-fill"></i> Locked</button>


                                        <ng-container *ngIf="mock.lock">
                                            <button class="desk-none"
                                                style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                                mat-flat-button color="primary">
                                                <i class="bi bi-lock-fill"></i> </button>
                                        </ng-container>

                                    </div>
                                </ng-template>

                            </li>
                        </ng-container>

                    </ul>
                </div>


            </div>
            <div class="col-md-9">
                <div class="load-more">
                    <button *ngIf="tabVal == 'past' && loadmore2 < pastList.length" mat-button (click)="loadmore()">Load
                        More</button>
                    <button *ngIf="tabVal == 'past' && loadmore2 == pastList.length" mat-button
                        (click)="loadless()">Load Less</button>
                    <button *ngIf="tabVal == 'full' && loadmore1 < fullmockDetailList.length" mat-button
                        (click)="loadmore()">Load More</button>
                    <button *ngIf="tabVal == 'full' && loadmore1 == fullmockDetailList.length" mat-button
                        (click)="loadless()">Load Less</button>
                    <button
                        *ngIf="tabVal == 'sectional' && (loadmore2 < quantMockList.length || loadmore2 < varcMockList.length || loadmore2 < lrdiMockList.length)"
                        mat-button (click)="loadmore()">Load More</button>
                    <button
                        *ngIf="tabVal == 'sectional' && (loadmore2 == quantMockList.length || loadmore2 ==  varcMockList.length || loadmore2 == lrdiMockList.length)"
                        mat-button (click)="loadless()">Load Less</button>
                </div>
            </div>


        </div>
    </div>

</div>

<div class="career_opens_main py-md-5" id="mocks" *ngIf="mockName == 'IPMAT'">
    <div class="container">
        <div class="row d-flex justify-content-center">
            <div class="col-md-12">
                <h2>IPMAT Mocks</h2>
            </div>

            <app-ipmat-mock-attempt></app-ipmat-mock-attempt>
        </div>
    </div>
</div>

<div class="clearfix"></div>


<div class="quiz_topics" *ngFor="let mockmain of mockDataList; let j = index">
    <h4 class="text-center p-2">{{mockmain.sub_category}}</h4>
    <div class="quiz_card py-md-5" id="{{ 'subcat' + j }}">
        <div class="container">

            <div class="row d-flex justify-content-center">
                <div class="col-md-10 full_width_tab">
                    <div class="subcattitle">

                        <div class="accordiondiv">
                            <mat-accordion>
                                <mat-expansion-panel *ngFor="let mock of mockmain.mocks" (opened)="openMock(mock)">
                                    <mat-expansion-panel-header [collapsedHeight]="'65px'" [expandedHeight]="'65px'">
                                        <mat-panel-title>
                                            {{mock.mock_name}}
                                        </mat-panel-title>
                                        <mat-panel-description>

                                        </mat-panel-description>
                                    </mat-expansion-panel-header>

                                    <div class="row">
                                        <div class="col-md-3 mb-3 sticky-top">
                                            <ul class="nav nav-pills flex-column sticky-top" id="myTab" role="tablist">
                                                <ng-container *ngFor="let section of mock.sections|orderby;let i=index">
                                                    <li class="nav-item" *ngIf="section.section_details?.status"
                                                        (click)="openSection(section,i)">
                                                        <a class="nav-link "
                                                            [ngClass]="{'active': selectedMock?.id == section?.id && activeIndex == i}"
                                                            id="{{ 'object' + i }}" data-toggle="tab"
                                                            role="tab">{{section.section_details?.section_name}}
                                                        </a>
                                                    </li>
                                                </ng-container>


                                            </ul>
                                        </div>
                                        <!-- /.col-md-4 -->
                                        <div class="col-md-9 p-md-0">
                                            <div class="tab-content">
                                                <div class="tab-pane fade show active">
                                                    <div class="quiztable">
                                                        <div class="table-responsive">
                                                            <table class="table" class="w-100 mt-2">
                                                                <thead>
                                                                    <tr>
                                                                        <th> Take Test </th>
                                                                        <th class="w-30"> Mock Name </th>
                                                                        <th class="w-20"> No. of Questions </th>
                                                                        <th class="w-20"> Marks (of each) </th>
                                                                        <th class="w-20"> Time </th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr>
                                                                        <td>
                                                                            <!--  *ngIf="!profileData?.section_det.includes(mock.sections[activeIndex]?.id)" -->
                                                                            <button
                                                                                *ngIf="!profileData?.section_det.includes(mock.sections[activeIndex]?.id)"
                                                                                (click)="qa(mock?.sections[activeIndex],mock)"
                                                                                mat-flat-button>Take Test

                                                                            </button>
                                                                            <div class="analysis_btn">
                                                                                <button
                                                                                    *ngIf="profileData?.section_det.includes(mock.sections[activeIndex]?.id)"
                                                                                    (click)="qa(mock?.sections[activeIndex],mock)"
                                                                                    mat-flat-button>Re-Test

                                                                                </button>
                                                                                <button class="ml-2"
                                                                                    *ngIf="profileData?.section_det.includes(mock.sections[activeIndex]?.id)"
                                                                                    (click)="analysis(mock?.sections[activeIndex],mock)"
                                                                                    mat-flat-button>Analysis

                                                                                </button>

                                                                            </div>



                                                                        </td>
                                                                        <td>{{mock?.sections[activeIndex]?.section_details?.section_name}}
                                                                        </td>
                                                                        <td>{{mock?.sections[activeIndex]?.section_details?.noofquest}}
                                                                        </td>
                                                                        <td>{{mock?.sections[activeIndex]?.section_details?.eachmarks}}
                                                                        </td>
                                                                        <td>{{mock?.sections[activeIndex]?.section_details?.time}}
                                                                        </td>

                                                                    </tr>

                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- /.col-md-8 -->
                                    </div>

                                </mat-expansion-panel>

                            </mat-accordion>
                        </div>

                    </div>


                </div>
            </div>



        </div>
        <!-- /.container -->
    </div>
</div>






<div class="clearfix"></div>
<!-- <div class="full_gred takefree full_gred3 py-md-4">
    <div class="container">
        <div class="row d-md-flex justify-content-center">
            <div class="col-md-9 full_width_tab">
                <div class="d-md-flex justify-content-between py-md-3">
                    <div class="free_cat">
                        <h3>Download all CAT Formulas, Theorems as PDF</h3>
                        <p>Get all important formulaes, tips, tricks, theorems</p>
                    </div>

                    <div class="free_cat_btn">
                        <button mat-raised-button (click)="icatmock()">Click to start mock</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->


<div class="clearfix"></div>
<div class="inner_hero_text pt-md-5">
    <div class="container">
        <div class="row d-flex justify-content-center">
            <div class="col-md-11 full_width_tab">
                <p [innerHTML]="pastPaperData | safeHtml"></p>
            </div>
        </div>
    </div>
</div>

<div class="faqs" *ngIf="mockName == 'CAT'">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-8">
                <div class="head">
                    <h2>FAQs on CAT Previous Year Papers </h2>
                </div>
            </div>
        </div>
        <div class="gradent-bg">
            <div class="faqs-list">
                <div class="row justify-content-center">
                    <div class="col-md-8">
                        <div class="faqcard">
                            <ul id="accordion" class="accordion">
                                <li *ngFor="let menu of faqList; let i = index">
                                    <div class="menu" (click)="toggle(i)">
                                        <h3>
                                            <span>Q{{i+1}}.</span> {{ menu.name }}
                                        </h3>
                                        <i class="bi bi-plus" *ngIf="!menu.active"></i>
                                        <i class="bi bi-dash-lg" aria-hidden="true" *ngIf="menu.active"></i>
                                    </div>
                                    <div class="submenu" #submenu
                                        [style.height.px]="menu.active ? submenu.scrollHeight : 0">
                                        <div class="acco_info">
                                            <div *ngFor="let submenu of menu.submenu">
                                                <p>{{ submenu.answer }}</p>
                                                <p *ngFor="let subanswer of submenu.subanswers">{{subanswer}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="faqs" *ngIf="mockName == 'CLAT'">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-8">
                <div class="head">
                    <h2>FAQs on CLAT Previous Year Papers </h2>
                </div>
            </div>
        </div>
        <div class="gradent-bg">
            <div class="faqs-list">
                <div class="row justify-content-center">
                    <div class="col-md-8">
                        <div class="faqcard">
                            <ul id="accordion" class="accordion">
                                <li *ngFor="let menu of faqListclat; let i = index">
                                    <div class="menu" (click)="toggle1(i)">
                                        <h3>
                                            <span>Q{{i+1}}.</span> {{ menu.name }}
                                        </h3>
                                        <i class="bi bi-plus" *ngIf="!menu.active"></i>
                                        <i class="bi bi-dash-lg" aria-hidden="true" *ngIf="menu.active"></i>
                                    </div>
                                    <div class="submenu" #submenu
                                        [style.height.px]="menu.active ? submenu.scrollHeight : 0">
                                        <div class="acco_info">
                                            <div *ngFor="let submenu of menu.submenu">
                                                <p>{{ submenu.answer }}</p>
                                                <p *ngFor="let subanswer of submenu.subanswers">{{subanswer}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>




<div class="new-content" *ngIf="mockName == 'Free CAT Study Material'">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-9">
                <div class="text">
                    <ul>

                        <li>
                            <h2>CAT Study Material FAQs</h2>

                            <ul>
                                <li>
                                    <h3>1. What is the best material for CAT?</h3>
                                    <p> The best material for CAT is the iConcept material by iQuanta for free. IIM ABC
                                        Batch is the iQuanta Exclusive batch consisting of 7500+ CAT level questions.
                                        These questions are highly relevant to the CAT exam and will be of great help in
                                        cracking the top B-schools.</p>
                                </li>
                                <li>
                                    <h3>2. How to get free CAT study material?</h3>
                                    <p> All the sources mentioned in the blogs are mostly free. You can also visit the
                                        iConcept section on the iQuanta website to get access to free CAT material.</p>
                                </li>
                                <li>
                                    <h3>3. Is it easy to get a 100%ile in CAT?</h3>
                                    <p> Nothing comes easy in this world. Your hard work and level of dedication will
                                        determine the level of easiness or difficulty you'll feel in your CAT
                                        preparation. Following all the aforementioned steps in the blog will definitely
                                        play a big role in scoring 100%ile in CAT.</p>
                                </li>
                            </ul>


                        </li>

                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="xat-bottom-content" *ngIf="mockName == 'XAT'">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-10 full_width_tab">
                <h2 class="mt-md-4 text-center">Why Solve XAT Previous Year Papers? </h2>
                <p>XAT Previous year papers evaluate the degree of complexity, by analyzing PYQ candidates can measure
                    the difficulty of the XAT exam. It helps in time management. You will be able to figure out the
                    exact time needed for each question and will be familiarized with the level of questions asked every
                    year, in this way, students get an idea of how they should allocate the time required in different
                    sections. </p>
                <p>Although the XAT syllabus gives a broad image of all the topics, the XAT previous year questions
                    picture the exact pattern and format of repeating or common questions every year. This familiarity
                    with paper helps students target the actual topics rather than going for the whole bucket of topics
                    and avoiding unnecessary elements from your strategy. This will help you deal with your anxiety and
                    help you in preparing a relevant strategy.</p>
                <p>XAT previous year question papers are the best trustable source to calculate the areas where you lack
                    and where you are proficient, this will help you in putting the exact time needed for your weak
                    points and reinforcing their strong points. PYQ is the biggest asset for aspirants in any
                    competitive exam.</p>
                <p>Increasing pace and accuracy is essential for scoring good grades in XAT. Practicing through previous
                    year question papers can help candidates in increasing time and speed per question and this way they
                    can attempt a maximum number of questions in a given time and make good grades in XAT.</p>
                <p>Confidence in XAT exams can help you in clearing your exams and students can gain confidence by
                    solving PYQ again and again, this will make them familiar with the pattern of questions asked and
                    can significantly boost the confidence of students.</p>
                <p>The decision-making section is one of the trickiest sections and if candidates are not aware of the
                    pattern, then it will bring difficulty as this is not some subject that you have previously
                    acquainted with. Hence, solving XAT Previous Year Papers will help you in analysing exactly what
                    types of questions are asked in the exam.</p>


            </div>
        </div>
    </div>
</div>



<div class="joinquantamain my-md-5">
    <div class="container">
        <div class="row">
            <div class="col-md-1"></div>
            <div class="col-md-10 full_width_tab">

                <div class="joinquanta d-md-flex">
                    <div class="subsc mr-auto">
                        <p>Ask your Doubts in any question you face in this iQuanta Facebook Group
                            <br> Benefit From Our Exceptional Pedagogy in our CAT Paid Course
                            <br> Be a Part of our Learning Network
                        </p>
                        <h4>Join iQuanta Facebook Group</h4>
                    </div>
                    <div class="sub_btn middle">
                        <button mat-flat-button color="primary" (click)="fbgroup()">Join CAT Facebook Group</button>
                    </div>

                </div>
            </div>
            <div class="col-md-1"></div>
        </div>
    </div>
</div>







<app-footer [hideBarFlag]="false" (change1)="changeQuiz1($event)"></app-footer>